const Save = ({ attributes }) => {
  const { variant, margin, background, size } = attributes;

  return (
    <hr
      className={`divider ${variant} ${margin} ${background}`}
      style={{ borderTopWidth: `${size}px` }}
    />
  );
};

export default Save;
